import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {useState} from 'react'
import ReportErrorFeedback, {ERROR_FEEDBACK_ENABLED} from '~/components/ReportErrorFeedback'
import {Button} from '~/ui/Button/Button'
import {twStyled} from '../../ui/twStyled'
import {
  isExtensionError,
  isIgnoredError,
  isNetworkError,
  isOldBrowserError
} from '../../utils/errorFilters'

const ErrorBlock = twStyled('div')(
  'flex h-full w-full flex-col items-center justify-center text-center'
)






const ErrorComponent = (props) => {
  const {error, eventId} = props
  if (!isIgnoredError(error)) {
    console.error(error)
  }
  const [isOpen, setIsOpen] = useState(false)

  if (isExtensionError(error)) {
    return (
      _jsxs(ErrorBlock, { children: [
        _jsx('div', { children: "Oh no! Seems like you're using Google Translate or a similar extension, which has a bug in it that can crash apps like ours."


        })
        , _jsx('div', { children: "If this continues, please disable the extension"      })
        , _jsx(Button, {
          variant: "primary",
          size: "sm",
          className: "mt-2",
          onClick: () => window.location.reload(),
 children: "Refresh the page"

        })
      ]})
    )
  }

  if (isOldBrowserError(error)) {
    const url = 'https://browser-update.org/update-browser.html'
    return (
      _jsxs(ErrorBlock, { children: [
        "Oh no! You've found a bug because the browser you're using needs to be updated."
        , _jsx(Button, { variant: "primary", size: "sm", className: "mt-2", children: 
          _jsx('a', { className: "text-inherit", href: url, target: "_blank", rel: "noreferrer", children: "Update now"

          })
        })
      ]})
    )
  }

  if (isNetworkError(error)) {
    return (
      _jsxs(ErrorBlock, { children: ["There was a network issue. Please check your connection and try again."

        , _jsx(Button, {
          variant: "primary",
          size: "sm",
          className: "mt-2",
          onClick: () => window.location.reload(),
 children: "Refresh the page"

        })
      ]})
    )
  }

  return (
    _jsxs(ErrorBlock, { children: [
      'An error has occurred! We’ve alerted the developers. Try refreshing the page'
      , ERROR_FEEDBACK_ENABLED && eventId && (
        _jsx(Button, { variant: "primary", size: "sm", className: "mt-2", onClick: () => setIsOpen(true), children: "Report Feedback"

        })
      )
      , _jsx(ReportErrorFeedback, {
        isOpen: isOpen,
        onClose: () => setIsOpen(false),
        error: error,
        eventId: eventId,}
      )
    ]})
  )
}

export default ErrorComponent
